export const IconList: {
  name: 'icon_list-fc634da1b3d0'
} = {
  name: 'icon_list-fc634da1b3d0'
}
